var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tinymce',{attrs:{"init":_vm.tinymceInit,"id":_vm.editorId},on:{"change":_vm.onEditorChange},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }